import styled from 'styled-components';
import { Select } from 'antd';
export const SelectStyled = styled(Select)`
  .ant-select-selection-item {
    font-size: 14px;
  }
  .ant-select-selection-placeholder {
    font-size: 14px;
  }
`;
